import { render, staticRenderFns } from "./PayoutsPieChartMultiViewCard.vue?vue&type=template&id=630d1398&"
import script from "./PayoutsPieChartMultiViewCard.vue?vue&type=script&lang=js&"
export * from "./PayoutsPieChartMultiViewCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports